export const TILE_PALETTE = [
  "bg-tile-people",
  "bg-tile-energy",
  "bg-tile-calendar",
  "bg-tile-success",
  "bg-tile-media",
  "bg-tile-schedule",
  "bg-tile-achievement",
  "bg-tile-info",
  "bg-tile-alert",
  "bg-tile-warn"
] as const;

export type TilePaletteClass = (typeof TILE_PALETTE)[number];

const hashId = (id: string | number) => {
  const str = String(id);
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

export const tileForId = (id: string | number): TilePaletteClass =>
  TILE_PALETTE[hashId(id) % TILE_PALETTE.length]!;

const NO_REPEAT_WINDOW = 4;

/**
 * Maps a list of ids to tile colors, guaranteeing no two cards within the
 * last NO_REPEAT_WINDOW positions share a color. Each id starts at its
 * stable hash position; on collision, advances to the next free slot.
 */
export const tilesForIds = (
  ids: ReadonlyArray<string | number>
): TilePaletteClass[] => {
  const result: TilePaletteClass[] = [];
  const window = Math.min(NO_REPEAT_WINDOW, TILE_PALETTE.length - 1);
  for (const id of ids) {
    let pick = hashId(id) % TILE_PALETTE.length;
    const recent = new Set(result.slice(-window));
    while (recent.has(TILE_PALETTE[pick]!)) {
      pick = (pick + 1) % TILE_PALETTE.length;
    }
    result.push(TILE_PALETTE[pick]!);
  }
  return result;
};
